/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createIsZero } from '../../factoriesAny.js';
export var isZeroDependencies = {
  typedDependencies,
  createIsZero
};